// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import filterService from '../../../services/filterService/FilterService';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class UrlCallbacksPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'urlCallbacks';
        this.Server = this.props.context.getState().server.urlCallbacks;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid',]; // 'request#uuid', 'request#merchantOrder''
        this.dateRangeField = 'createdAt';

        this.searchOp = filterService.OPERATORS.EQUAL;

        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'url',
                label: 'url',
                alignRight: false,
                cell: 'Url',
                displayGrid: true
            },
            {
                id: 'signature',
                label: 'signature',
                alignRight: false,
                cell: 'Text',
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'request',
                label: 'request',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json',
                disableEditor: true
            },
            {
                id: 'response',
                label: 'response',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json',
                disableEditor: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'State',
                items: ['retry', 'success', 'fail'],
                displayGrid: true
            },
            {
                id: 'executionTime',
                label: 'executionTime',
                alignRight: false,
                cell: 'Time', // TODO: Create Time cell
                displayGrid: true
            },
            {
                id: 'history',
                label: 'history',
                alignRight: false,
                cell: 'Text',
                displayDialogDetails: true,
                details: 'Json',
                disableEditor: true
            },
            {
                id: 'retriesRemaining',
                label: 'retriesRemaining',
                alignRight: false,
                cell: 'Number',
                type: 'number',
                displayGrid: true
            },
            {
                id: 'nextRetry',
                label: 'nextRetry',
                alignRight: false,
                cell: 'Date',
                disableEditor: true,
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['createdAt', 'updatedAt'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'createdAt',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    customLogicOnMount = async () => {
        // const endDate = new Date();
        // const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        // const lastWeek = formatDate(startDate, endDate);
        // this.dateRangeSave(lastWeek);

        const state = this.props.location?.state;
        const searchValue = state?.searchValue || '';
        if (searchValue) {
            await this.search(searchValue);
        }
    };

    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];
    }
}
